const ArchiveMusicVideos2022Static = () => {
    return (
      <>
        <div class="music-video">

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/k-7oPEbGaC8" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            KEANO
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/0PDDyumLrYo" title="SWAG SUPPLIER" allowfullscreen></iframe>
            </div>
            <p class="video-title-text">
            <strong>ANJU Online! & Kawaii Ry</strong><br/>
            SWAG SUPPLIER (feat. STARINTHESKY)
            </p>

            <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/8sln1klp718" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            Morose (prod. Mista)
          </p>

            <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/pvQjdOQjEOM" title="Lugosi - ghostsinthewalls" allowfullscreen></iframe>
            </div>
            <p class="video-title-text">
            <strong>Lugosi</strong><br/>
            ghostsinthewalls (prod. ANJU Online!)
            </p>

            <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/b2FZYmcVDik" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            Eight
          </p>

            <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/25C4IdLIRj0" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            Like This (prod. Goyxrd)
          </p>

            <div class="music-video-container">
                <iframe src="https://www.youtube.com/embed/Rg1IqE0vr7s" title="Hellscape Radio Vol. 3" allowfullscreen></iframe>
            </div>
            <p class="video-title-text">
                <strong>Josen</strong><br/>
                ZA [OFFICIAL ZAZA ANTHEM]
            </p> 

            <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/esF2fVJ9zdg" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            LOOT
          </p>

            <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/jTwGVGjjnLM" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            QUOTE US
          </p>
            
        </div>
      </>
    );
  };
  export default ArchiveMusicVideos2022Static;